import { useState } from "react";

export interface UseBottomSheetReturn {
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
}

export const useBottomSheet = (): UseBottomSheetReturn => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    handleOpen,
    handleClose,
  };
};

export default useBottomSheet;
